<template>
  <div>
    <div v-if="!addTeamFlag && !teamPermissionsFlag">
      <div class="col-sm-12 col-xs-12">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-6 col-xs-8">
            <search-box v-model="searchValue" @getList="filterTeamsList"></search-box>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-6 col-xs-4 text-right">
            <button class="btn emergo-blue-button" @click="addTeamMemberSection">
              <img class="add_icon_img" src="/static/images/icons/plus_icon.svg" alt="plus-icon" />
              Add
              <span class="hidden-xs">Team Member</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mr-tp-10">
        <div class="toggle_switch">
          <span>Two Factor Authentication</span>
          <label class="switch">
            <input
              type="checkbox"
              v-model="multi_factor_key"
              @change="updateMultiFactorAuthentication()"
            />
            <span class="slider round"></span>
          </label>
          <span v-if="multi_factor_key" class="switch_label">On</span>
          <span v-else class="switch_label switch_off">Off</span>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mr-bt-10">
        <div class="row">
          <div class="col-md-11 col-sm-11 col-xs-10">
            There are {{ teamMemberCount }} active team members.
          </div>
          <div class="col-md-1 col-sm-1 col-xs-2 text-alg-right">
            <el-popover
              placement="bottom-end"
              trigger="click"
              @show="infoActive = true"
              @hide="infoActive = false"
              :key="roles.length"
              width="350"
            >
              <!-- <template #reference> -->
              <img
                class="info-img"
                src="/static/images/icons/info_icon.svg"
                v-if="!infoActive"
                alt="info-icon"
                slot="reference"
              />
              <img
                class="info-img"
                src="/static/images/icons/info_icon_active.svg"
                v-if="infoActive"
                alt="infoactive-icon"
                slot="reference"
              />
              <!-- </template> -->
              <div class="info-tabs">
                <ul class="nav nav-tabs" role="tablist">
                  <li role="presentation" class="nav-item" :class="{ active: activeTab == 'role' }">
                    <span class="nav-link" role="tab" data-toggle="tab">Role Definitions</span>
                  </li>
                </ul>
                <div>
                  <div v-for="(role, index) in roles" :key="index">
                    <div class="info-header">{{ role.name }}</div>
                    <div class="info-text">{{ role.description }}</div>
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 hidden-xs">
        <div class="row member-box-wrapper">
          <div class="col-md-1 col-sm-1 col-xs-1 p-0 custom-checkbox sm-txt-alg-lt">
            <span class="checkbox">
              <label>
                <input type="checkbox" class="form-control" v-model="selectAll" />
                <span class="cr"></span>
              </label>
            </span>
          </div>
          <div class="col-sm-5">
            <span class="mr-lt-33 info-header member_label">Member</span>
          </div>
          <div class="col-sm-6 p-0">
            <template v-if="!multi_factor_key">
              <div class="col-sm-6 info-header">Role</div>
              <div class="col-sm-6 info-header">Distributor</div>
            </template>
            <template v-else>
              <div class="col-sm-4 info-header">Role</div>
              <div class="col-sm-4 info-header">Distributor</div>
              <div class="col-sm-4 info-header">IP Address</div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 container1">
        <div class="section">
          <div class="col-md-12 col-sm-12 col-xs-12 scrollable-content">
            <div
              class="row member-box-wrapper"
              v-for="(member, index) in filterMembers"
              :key="index"
              :class="{ 'opacity-7': loggedInUser.id === member.user_id }"
            >
              <template v-if="loggedInUser.id !== member.user_id">
                <div
                  class="col-md-1 col-sm-1 col-xs-2 p-0 sm-txt-alg-lt mt-4"
                  v-if="validateRemoveAuthority(member.assigned_role_id)"
                >
                  <div>
                    <span class="checkbox inline-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        class="form-control"
                        v-model="checkedValue"
                        :value="member.user_id"
                      />
                      <span class="cr"></span>
                    </label>
                   </span>
                    <i class="fa fa-pencil" aria-hidden="true" @click="openRbacPage(member)"></i>
                  </div>
                </div>
                <div class="col-md-1 col-sm-1 col-xs-2 p-0 sm-txt-alg-lt" v-else>
                  <i class="fa fa-pencil" aria-hidden="true" @click="openRbacPage(member)"></i>
                </div>
              </template>
              <div
                class="col-sm-5 col-xs-10 pl-0"
                :class="{ 'col-sm-offset-1 col-xs-offset-2': loggedInUser.id === member.user_id }"
              >
                <div class="col-md-12 col-xs-12 col-sm-12 xs-pd-rt-0 pl-0">
                  <div class="member_img">
                    <span v-if="member.profile_pic" class="relative-pos">
                      <img class="profile-pic" :src="member.profile_pic" alt="profile-icon" />
                      <img
                        v-if="member.is_restricted"
                        class="notification-red-on-image"
                        src="/static/images/icons/blocked_icon.png"
                        alt="blocked-icon"
                      />
                    </span>
                    <span
                      class="profile-pic profile-pic-title custom-profile-pic-title relative-pos"
                      v-else
                      >{{ getInitials(member.first_name, member.last_name) }}
                      <img
                        v-if="member.is_restricted"
                        class="notification-red"
                        src="/static/images/icons/blocked_icon.png"
                        alt="blocked-icon"
                      />
                    </span>
                    <!-- <span v-if="!member.is_restricted"><img  v-if="!member.is_restricted" class="notification-red" src="/static/images/icons/blocked_icon.png" /></span> -->
                  </div>
                  <div class="member-text">
                    <div class="member-name">{{ member.first_name + ' ' + member.last_name }}</div>
                    <div class="ft-wt member-name">{{ member.email }}</div>
                  </div>
                  <div class="arrow-disp" @click="dropDownEvent(member.id)">
                    <div
                      class="xs-collapse-arrow"
                      v-bind:class="!xshide[member.id] ? 'active' : ''"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <team-member
                  @updateRole="updatedRole"
                  @updateDistributor="emitedDistributor"
                  :roles="listAllRoles"
                  :roleId="roleId"
                  :member="member"
                  :localDistributors="localDistributors"
                  :selectedRolesList="selectedRolesList[member.id]"
                  :xshide="xshide[member.id]"
                  :multi_factor_key="multi_factor_key"
                ></team-member>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 footer remove_button_padding">
        <div class="col-md-4 col-sm-4 col-xs-12 xs-mr-bt-10 xs-pd-lt-0 xs-pd-rt-0">
          <button
            type="button"
            class="btn btn-block emergo-blue-button"
            @click="openDeleteConfirmationPopup"
            :disabled="checkedValue.length === 0"
          >
            Remove Member(s)
          </button>
        </div>
      </div>
    </div>
    <template v-if="addTeamFlag">
      <add-team-member
        :roles="roles"
        :multi_factor_key="multi_factor_key"
        :member="selectedMember"
        :localDistributors="localDistributors"
        @cancelAddTeam="cancelAddTeam"
        @getTeamMembers="getTeamMembers"
        :account_type_id="loggedInUser.account_type_id"
      >
      </add-team-member>
    </template>
    <template v-if="teamPermissionsFlag">
      <edit-team-member
        :roles="roles"
        :multi_factor_key="multi_factor_key"
        :member="selectedMember"
        @cancelAddTeam="cancelAddTeam"
        @getTeamMembers="getTeamMembers"
        :distributors="localDistributors"
        :account_type_id="loggedInUser.account_type_id"
      >
      </edit-team-member>
    </template>
    <loader :loadingStatus="loaderStatus"></loader>
    <generic-popup
      :genericPopupId="genericPopupId"
      :genericHeader="'Team Limit'"
      :genericBody="'upgradeTeams'"
      :max_number="max_team_members"
      @emitUpgradeTeams="upgradeTeams"
      :isREP="loggedInUser.account_type_id === 2 || loggedInUser.account_type_id === 4"
    ></generic-popup>
    <upgrade-modal
      :addonType="'account'"
      @payForUpgradeService="payForUpgradeService"
    ></upgrade-modal>
    <delete-popup
      :deletewarnInfo="deleteWarningInfo"
      :teamMembersList="teamMembersName"
      @dashboardPublishDelete="removeTeamMember()"
    >
    </delete-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import { Popover } from 'element-ui';
import EventBus from '../../../utils/event-bus';
import Loader from '../../UIComponents/Loader.vue';
import SearchBox from '../../UIComponents/SearchBox.vue';
import {
  removeTeamMember,
  getTeamMembers,
  getMultiFactorAuthentication,
  updateMultiFactorAuthentication
} from '../../../apis/team';
import { isDefaultDashboard, setDefaultPreference } from '../../../apis/dashboardCustomization';
import TeamMember from './TeamMember.vue';
import EditTeamMember from './EditTeamMember.vue';
import { getRolesList, getUserData, getProfileData } from '../../../apis/profile';
import { getLocalDistributor } from '../../../apis/registrations';
import GenericPopup from '../../UIComponents/GenericPopup.vue';
import UpgradeModal from '../CommonComponents/UpgradeModal.vue';
import DeletePopup from '../../UIComponents/DeleteRegHeadlinePopup.vue';
import AddTeamMember from './AddTeamMember.vue';
import { getAddonDetails } from '../../../apis/psm';
import { getListOfRoleNames } from '../../../apis/rbac';
// import BasePopover from '../../Common/BasePopover.vue';

export default {
  components: {
    DeletePopup,
    Loader,
    TeamMember,
    GenericPopup,
    UpgradeModal,
    SearchBox,
    EditTeamMember,
    AddTeamMember,
    // BasePopover,
    'el-popover': Popover
  },
  props: ['roleId', 'closeSubPage', 'resetTeams'],
  data() {
    return {
      deleteWarningInfo: {
        loaderStatus: false,
        title: 'Are you sure you want to remove your team member(s)'
      },
      isPreviouslySearched: false,
      rolesList: [], // Original roles based on account type
      listAllRoles: [], // All Roles irrespective of active status
      disableDistributorUpdate: true,
      errors: [],
      addTeamFlag: false,
      teamPermissionsFlag: false,
      loaderStatus: false,
      addMemberError: '',
      roles: [], // modified list during edit team member
      localDistributors: '',
      teamMembersList: '',
      filterMembers: [],
      placeValue: 'Select Role',
      team: {
        name: '',
        email: '',
        role: '',
        assigned_distributor_id: null
      },
      updateRoleList: [],
      selectedRolesList: [],
      searchValue: '',
      checkedValue: [],
      infoActive: false,
      activeTab: 'role',
      xshide: [],
      max_team_members: 0,
      current_members: 0,
      genericPopupId: 'genericPopupTeam',
      recordAddonService: null,
      teamAddonService: null,
      selectedMember: '',
      servicesList: [],
      Permissions: '',
      multi_factor_key: false,
      loggedInUser: null
    };
  },
  computed: {
    teamMemberCount() {
      return this.filterMembers.filter((member) => !member.is_restricted).length;
    },
    teamMembersName() {
      const arrName = [];
      if (this.checkedValue.length) {
        for (let i = 0; i < this.checkedValue.length; i += 1) {
          const member = this.teamMembersList.find(
            (memberObj) => memberObj.user_id === this.checkedValue[i]
          );
          if (member) {
            arrName.push(`${member.first_name} ${member.last_name}`);
          }
        }
      }
      return arrName;
    },
    selectAll: {
      get() {
        return this.allMemberIds.length
          ? this.checkedValue.length === this.allMemberIds.length
          : false;
      },
      set(value) {
        const selected = [];
        if (value) {
          this.allMemberIds.forEach((id) => {
            if (this.loggedInUser.id !== id) selected.push(id);
          });
        }
        this.checkedValue = selected;
      }
    },
    allMemberIds() {
      const allIds = [];
      this.filterMembers.forEach((curMember) => {
        allIds.push(parseInt(curMember.user_id, 10));
      });
      return allIds;
    }
  },
  watch: {
    // async addTeamFlag() {
    //   if (this.addTeamFlag) {
    //     await this.getRoles();
    //     await this.getTeamMembers();
    //   }
    // },
    closeSubPage(val) {
      if (val === 'close') {
        this.cancelAddTeam();
      }
    }
  },
  async created() {
    this.loggedInUser = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    await this.getRoles();
    await this.listOfAllRoles();
    await this.getDistributors();
    await this.getTeamMembers();
    await this.getMultiFactorAuthentication();
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    openDeleteConfirmationPopup() {
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },

    async updateMultiFactorAuthentication() {
      this.loaderStatus = true;
      const response = await updateMultiFactorAuthentication({ mfa: this.multi_factor_key });
      this.loaderStatus = false;
      if (response && response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Updated Two Factor Autentication successfully',
          group: 'custom-notification'
        });
      } else {
        this.multi_factor_key = !this.multi_factor_key;
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update Two Factor Authentication',
          group: 'custom-notification'
        });
      }
    },
    async getMultiFactorAuthentication() {
      this.loaderStatus = true;
      const response = await getMultiFactorAuthentication();
      this.loaderStatus = false;
      if (response) {
        this.multi_factor_key = response.mfa;
      }
    },
    cancelAddTeam() {
      this.addTeamFlag = false;
      this.teamPermissionsFlag = false;
      this.$emit('emitBreadCrumb', false);
    },
    // open role based permission page
    openRbacPage(member) {
      this.selectedMember = member;
      if (this.roles.findIndex((role) => role.id === member.role_id) === -1) {
        // Validate selected role id found in the roles
        const selectedRoleDetails = this.listAllRoles.find(
          (role) => role.role_id === member.role_id
        );
        this.roles.push({ id: selectedRoleDetails.role_id, name: selectedRoleDetails.role_name });
      }
      this.teamPermissionsFlag = true;
      this.$emit('emitBreadCrumb', 'Member');
    },
    upgradeTeams() {
      $('#UpgradeModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    upgradeRegPathwayAddOn() {
      $('#UpgradeModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async payForUpgradeService(service, selection = {}, isRenewal = false) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData')
        ? JSON.parse(localStorage.getItem('profileData'))
        : await getProfileData();
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      if (userData.id === profileData.id) {
        this.handleTeamMemberUpdate(service, selection, isRenewal);
      }
    },
    handleTeamMemberUpdate(service, selection, isRenewal) {
      service.isRenewal = isRenewal;
      const teamMemberData = {
        selection,
        service
      };
      sessionStorage.removeItem('upgradeServices');
      if (this.$route.path === '/layout/market-place/upgrade-service') {
        teamMemberData.isTeamMember = true;
        EventBus.$emit('upgradeService', teamMemberData);
      } else {
        this.$router.push({
          name: 'UpgradeService',
          params: {
            upgradeTeamMember: teamMemberData
          }
        });
      }
    },

    filterTeamsList() {
      if (this.searchValue) {
        this.filterTeamMembers();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterTeamMembers();
        this.isPreviouslySearched = false;
      }
    },

    dropDownEvent(id) {
      this.$set(this.xshide, id, !this.xshide[id]);
    },
    validateRemoveAuthority(assignedRoleId) {
      if (this.roleId === 9) {
        if (assignedRoleId !== 1 && assignedRoleId !== 5 && assignedRoleId !== 6) {
          return true;
        }
      } else {
        return true;
      }
      return false;
    },
    updatedRole(respObj) {
      this.selectedRolesList[respObj.member.id].id = respObj.selectedId;
      this.updateRole(respObj.member);
    },
    emitedDistributor(membobj) {
      this.updateRoleDistributor(membobj.id, membobj.dist_id);
      this.checkChanges();
    },
    async filterTeamMembers() {
      const searchStr = this.searchValue.trim();
      this.filterMembers = [];
      if (!searchStr.length) {
        this.filterMembers = this.teamMembersList;
        return;
      }
      this.filterMembers = this.teamMembersList.filter((each) =>
        this.searchString(searchStr, each)
      );
      this.validateCheckedValue();
    },
    validateCheckedValue() {
      const check = [];
      for (let i = 0; i <= this.checkedValue.length; i += 1) {
        if (this.validateFilterMemberVal(this.checkedValue[i])) {
          check.push(this.checkedValue[i]);
        }
      }
      this.checkedValue = check;
    },
    validateFilterMemberVal(id) {
      let valid = false;
      for (let member = 0; member < this.filterMembers.length; member += 1) {
        if (this.filterMembers[member].user_id === id) {
          valid = true;
          break;
        }
      }
      return valid;
    },
    searchString(searchValue, member) {
      if (member.first_name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if (member.email.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if (member.last_name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      const role = this.returnRoleName(member.assigned_role_id);
      if (role.search(new RegExp(searchValue, 'i')) !== -1) {
        return true;
      }

      if (this.validateDistributer(member, searchValue)) {
        return true;
      }
      return false;
    },
    returnRoleName(roleId) {
      const role = this.roles.find((each) => each.id === roleId);
      return role ? role.name : '';
    },
    validateDistributer(member, searchValue) {
      if (member.assigned_distributor_id) {
        const distributor = this.returnDistributerName(member.assigned_distributor_id);
        if (distributor.search(new RegExp(searchValue, 'i')) !== -1) {
          return true;
        }
      }
      return false;
    },
    returnDistributerName(distributorId) {
      const distributor = this.localDistributors.find((each) => each.id === distributorId);
      return distributor ? distributor.distributor_name : '';
    },
    updateRole(member) {
      const { id } = member;
      const role = this.selectedRolesList[id].id;
      const distributor = member.assigned_distributor_id;
      let flag = false;
      for (let i = 0; i < this.updateRoleList.length; i += 1) {
        if (this.updateRoleList[i].user_id === id) {
          this.updateRoleList[i].assigned_role_id = role;
          if (role === 6) this.updateRoleList[i].assigned_distributor_id = distributor;
          flag = true;
          break;
        }
      }
      if (!flag) {
        const data = {
          user_id: id,
          assigned_role_id: role
        };
        if (role && role === 6) data.assigned_distributor_id = distributor;
        this.updateRoleList.push(data);
      }
      this.checkChanges();
    },
    updateRoleDistributor(id, distributor) {
      let flag = false;
      for (let i = 0; i < this.updateRoleList.length; i += 1) {
        if (this.updateRoleList[i].user_id === id) {
          this.updateRoleList[i].assigned_distributor_id = distributor;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.updateRoleList.push({
          user_id: id,
          assigned_role_id: 6,
          assigned_distributor_id: distributor
        });
      }
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${
        lastname ? lastname.charAt(0).toUpperCase() : ''
      }`;
    },
    dateFormatForExpiry(date) {
      return moment.utc(date).format('YYYY-MM-DD');
    },
    async validateTeamUpgrade() {
      this.loaderStatus = true;
      const addonAccountDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      this.recordAddonService = addonAccountDetails.find((each) => each.units === 'RECORDS');
      this.teamAddonService = addonAccountDetails.find((each) => each.units === 'USERS');
      this.loaderStatus = false;
      if (this.teamAddonService) {
        if (
          this.teamAddonService.total_limit >= this.teamAddonService.default_limit &&
          this.teamAddonService.is_active &&
          moment().utc().format('YYYY-MM-DD') <=
            this.dateFormatForExpiry(this.teamAddonService.valid_until) &&
          moment().utc().format('YYYY-MM-DD') >=
            this.dateFormatForExpiry(this.teamAddonService.valid_from)
        ) {
          this.max_team_members = this.teamAddonService.total_limit;
        } else if (
          this.teamAddonService.total_limit >= this.teamAddonService.default_limit &&
          this.teamAddonService.is_active &&
          moment().utc().format('YYYY-MM-DD') >
            this.dateFormatForExpiry(this.teamAddonService.valid_until) &&
          moment().utc().format('YYYY-MM-DD') >=
            this.dateFormatForExpiry(this.teamAddonService.valid_from)
        ) {
          this.max_team_members = this.teamAddonService.default_limit;
        }
        this.current_members = this.teamAddonService.current_utilization;
      }
    },
    async addTeamMemberSection() {
      await this.validateTeamUpgrade();
      this.roles = [...new Set(this.rolesList)]; // To overRide actual roles at the time of creation
      if (this.current_members < this.max_team_members) {
        this.checkedValue = [];
        this.updateRoleList = [];
        this.team = {
          first_name: '',
          last_name: '',
          email: '',
          role: '',
          assigned_distributor_id: null,
          user_type_id: 1
        };
        this.addMemberError = '';
        this.searchValue = '';
        this.filterTeamMembers();
        this.addTeamFlag = true;
        this.$emit('emitBreadCrumb', 'New Member');
      } else {
        $(`#${this.genericPopupId}`).modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    async listOfAllRoles() {
      this.loaderStatus = true;
      this.listAllRoles = await getListOfRoleNames();
      this.loaderStatus = false;
    },
    async getRoles() {
      this.loaderStatus = true;
      this.rolesList = (await getRolesList()).filter(
        (role) => ![10,12,13,14,15].includes(role.id)
      );
      this.roles = [...new Set(this.rolesList)];
      this.loaderStatus = false;
    },
    async getDistributors() {
      this.loaderStatus = true;
      this.localDistributors = await getLocalDistributor();
      this.loaderStatus = false;
    },
    async getTeamMembers() {
      this.loaderStatus = true;
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      this.teamMembersList = await getTeamMembers(
        userData.account_type_id === 2 || userData.account_type_id === 4 ? 1 : 0
      );
      if (this.teamMembersList.length) {
        const index = this.teamMembersList.findIndex(
          (member) => member.user_id === this.loggedInUser.id
        );
        if (index > -1) {
          this.teamMembersList.unshift(this.teamMembersList[index]);
          this.teamMembersList.splice(index + 1, 1);
        }
      }
      this.filterMembers = this.teamMembersList;
      this.selectedRolesList = [];
      this.xshide = [];
      this.teamMembersList.forEach((curMember) => {
        this.selectedRolesList[curMember.id] = {
          id: curMember.role_id,
          name: this.returnRoleName(curMember.role_id)
        };
        this.xshide[curMember.id] = true;
      });
      this.loaderStatus = false;
    },
    async removeTeamMember() {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: true
      };
      const data = {
        userIds: this.checkedValue
      };
      const resp = await removeTeamMember(data);
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: false
      };
      $('#modal_delete').modal('hide');
      if (resp.status) {
        this.loaderStatus = true;
        this.checkedValue.forEach(async (id) => {
          const isDefault = await isDefaultDashboard(
            JSON.parse(localStorage.getItem('userData')).account_id,
            id
          );
          const defaultData = {
            account_id: JSON.parse(localStorage.getItem('userData')).account_id,
            user_id: id,
            dashboard_notification_type_id: 3
          };
          if (!isDefault) {
            await setDefaultPreference(defaultData);
          }
        });
        this.loaderStatus = false;
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Member removed successfully!',
          group: 'custom-notification'
        });
        this.checkedValue = [];
        await this.getTeamMembers();
        await this.filterTeamMembers();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: "Member couldn't be removed",
          group: 'custom-notification'
        });
      }
    },
    checkChanges() {
      let counter = 0;
      this.updateRoleList.forEach((data) => {
        if (data.assigned_role_id === 6 && data.assigned_distributor_id === null) counter += 1;
      });
      this.disableDistributorUpdate = true;
      if (counter === 0 && this.updateRoleList.length > 0) {
        this.disableDistributorUpdate = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.opacity-7 {
  opacity: 0.7;
}
.relative-pos {
  position: relative;
}
.notification-red {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  right: 0;
  bottom: -3px;
}
.notification-red-on-image {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  right: 0;
  top: 20px;
  left: 16px;
  bottom: 0;
}
.container1 {
  position: absolute;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  max-height: calc(84vh - 300px);
  padding-left: 230px;
  padding-right: 0px;
  margin-top: 233px;
}
.section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
}
.search-reset-label {
  right: 30px;
  top: 6px;
}
.custom-profile-pic-title {
  font-weight: $font-weight-medium;
  font-size: $font-14;
  line-height: 16px;
  background: #f2f2f2;
  color: #00518a !important;
}
.ft-wt {
  font-weight: $font-weight-small;
}
.xs-collapse-arrow {
  height: 14px;
  width: 14px;
  background-image: url(/static/images/icons/chevron_down.svg);
  background-repeat: no-repeat;
  &.active {
    background-image: url(/static/images/icons/chevron_up.svg);
  }
}
.arrow-disp {
  display: none;
}
.member-name {
  font-size: $font-14;
  line-height: 16px;
}
.member_img {
  display: table-cell;
  vertical-align: middle;
  padding-right: 15px;
}
.member-text {
  display: table-cell;
  word-break: break-all;
}
.mr-bt-10 {
  margin-bottom: 10px;
}
.mr-tp-10 {
  margin-top: 10px;
}
.info-header {
  font-weight: $font-weight-medium;
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
}
.info-text {
  font-weight: $font-weight-normal;
  font-size: $font-14;
  line-height: 16px;
  margin-bottom: 10px;
  color: $dark-black-alpha;
  text-align: left;
  word-break: break-word;
}
.info-img {
  height: 22px;
  width: 22px;
}
.modal-header {
  .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    font-weight: $font-weight-small;
    font-size: $font-30;
  }
}
.confirm-body {
  font-size: $font-14;
  padding: 15px;
}
.btn-width-confirm {
  width: 100px;
}
#container {
  height: 100%;
}
#add-team-footer {
  padding-bottom: 30px;
  padding-top: 10px;
}
.header-team {
  padding: 15px 0px 0px 0px;
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-28, 33px, $font-weight-small);
}
.icon-close {
  color: $deep-gray !important;
}
.add-border {
  width: 100%;
  border: 0.5px solid $deep-gray;
  box-sizing: border-box;
  border-radius: $radius20;
}
.add-dropdown-img {
  -webkit-appearance: none;
  background: url('/static/images/icons/chevron_down.svg') no-repeat right $white;
  background-position: 99% 50%;
}
.text-alg-right {
  text-align: right;
}
.mr-lt-33 {
  margin-left: 33px;
}
.member-box-wrapper {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 0.5px solid $gray74;
  margin: 0;
  i {
    color: $primary;
  }
}
.el-select-dropdown__item {
  &.selected {
    color: $primary;
  }
}
.confirmpopup-bgcolor {
  background-color: $deep-white;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.add_icon_img {
  display: none;
}
.reset-close-xs {
  display: none;
  top: 8px;
  right: 12%;
}
.nav {
  &.nav-tabs {
    margin-bottom: 15px;
  }
}
.switch {
    margin-left: 25px;
  }
@media only screen and (min-width: 1301px) {
  .remove_button_padding {
    padding-left: 230px;
  }
}
@media (width: 1024px) and (height: 768px) {
  .container1 {
    max-height: calc(84vh - 476px) !important;
  }
}
@media screen and (width: 768px) {
  .container1 {
    max-height: calc(84vh - 610px) !important;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1300px) {
  .container1 {
    max-height: calc(84vh - 330px) !important;
  }
}
@media screen and (max-width: 1300px) {
  .container1 {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: 265px;
  }
}
@media screen and (max-width: 767px) {
  .bt-border {
    padding-bottom: 10px;
  }
  .hide-xs {
    display: none;
  }
  .container1 {
    margin-top: 210px;
    max-height: calc(84vh - 250px);
  }
  .add_icon_img {
    display: inline !important;
  }
  .search-reset-label {
    display: none;
  }
  .reset-close-xs {
    display: block;
  }
  .arrow-disp {
    display: table-cell !important;
    vertical-align: middle;
  }
  .member-text {
    width: 96%;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
  .xs-mr-bt-10 {
    margin-bottom: 10px;
  }
  .footer {
    padding-bottom: 5%;
  }
}
@media screen and (max-width: 320px) {
  .switch {
    margin-left: 8px;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .container1 {
    margin-top: 225px;
    max-height: 17vh;
  }
  .footer {
    padding-bottom: 1%;
  }
  .mr-bt-10 {
    margin-bottom: 0px !important;
  }
  .mr-tp-10 {
    margin-top: 0px !important;
  }
  .member-box-wrapper {
    padding-top: 0px;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .container1 {
    margin-top: 190px;
    max-height: 15vh;
  }
  .footer {
    padding-bottom: 0%;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .container1 {
    margin-top: 200px;
    max-height: 25vh;
  }
  .footer {
    padding-bottom: 0%;
  }
}
</style>
